<div mat-dialog-content class="dialog-content p-4">
  <div class="dialog-header">
    <div class="confirm">
      <kendo-icon name="edit" size="medium"></kendo-icon>
    </div>
    <div class="dialog-close">
      <kendo-icon (click)="onCancel()" name="close" size="medium"></kendo-icon>
    </div>
  </div>
  <div class="dialog-body pt-2">
    <h2>Rename Survey</h2>
    <div class="rename-input-container">
      <label for="surveyName" class="form-label">Survey Name</label>
      <input
        id="surveyName"
        type="text"
        class="form-control"
        [formControl]="nameControl"
        (input)="onNameChange()"
        maxlength="80"
        aria-label="Survey name"
      />
      <div *ngIf="validationError" class="validation-error text-danger mt-1">
        {{ validationError }}
      </div>
    </div>
  </div>
  <div class="dialog-footer">
    <button class="dialog-button-default" (click)="onCancel()">
      <strong>Cancel</strong>
    </button>
    <button
      class="dialog-button"
      [disabled]="isSaveDisabled"
      (click)="onSave()"
    >
      Save
    </button>
  </div>
</div>
